import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({ providedIn: "root" })

export class WebcallsService {

    wsBaseURL = "";

	httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json;charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        })
    };

    constructor(
        private http: HttpClient
    ) {

    }

    setBaseUrl(value: string) {
        if (value.includes("demorooms") || value.includes("localhost")) {
          this.wsBaseURL = "https://myhomeaddon.demorooms.com/home/";
          //this.wsBaseURL = "http://localhost/btcapitolati/home/";
        } else {
          this.wsBaseURL = "https://configuracasa.bticino.it/home/";
        }
      }
    
    getBaseUrl() {
        return this.wsBaseURL;
    }

    getLocalization(host: string){
        const serviceUrl = 'getLocalization/';

    	return this.http.post(this.wsBaseURL + serviceUrl, {localizationHost : host}, {headers: this.httpOptions.headers}).pipe(
    		tap(localization => {
                return localization;
            }),
            catchError(this.handleError)
    	);
    }

    getUserIamJSON(){

    }

    getHousingTypes(){
        const serviceUrl = 'getHousingTypeJSON/';

    	return this.http.post(this.wsBaseURL + serviceUrl,{}, {headers: this.httpOptions.headers}).pipe(
    		map(housingTypes => {
                return housingTypes;
            }),
            catchError(this.handleError)
    	);
    }

    getListOfDistinctRoomTypes(localizationID: number) {
        const serviceUrl = 'getListOfDistinctRoomTypesByLocalization/';

        return this.http.post<any[]>(this.wsBaseURL + serviceUrl, {
            LocalizationID: localizationID
        }, {headers: this.httpOptions.headers}).pipe(
            map(rooms => {
                rooms = this.addImageClassToRooms(rooms);
                return rooms;
            }),
            catchError(this.handleError)
        );
    }

    getSystems(localizationID: number){
        const serviceUrl = 'getLocationSystemsJSON/' + localizationID;

    	return this.http.get(this.wsBaseURL + serviceUrl, {headers: this.httpOptions.headers}).pipe(
    		map(systems => {
                systems = this.addImageClassToSystems(systems);
                return systems;
            }),
            catchError(this.handleError)
    	);
    }

    getFinishingsByLocalization(localizationID: number){
        const serviceUrl = 'getFinishingsByLocalization/' + localizationID;

    	return this.http.get(this.wsBaseURL + serviceUrl, {headers: this.httpOptions.headers}).pipe(
    		map(finishings => {
                return finishings;
            }),
            catchError(this.handleError)
    	);
    }

    getSerieByID(serieID: number){
        const serviceUrl = 'getSerieByIDJSON/' + serieID;

    	return this.http.get(this.wsBaseURL + serviceUrl, {headers: this.httpOptions.headers}).pipe(
    		map(serie => {
                return serie;
            }),
            catchError(this.handleError)
    	);
    }

    getFinishing(localizationID: number, technologyID: number/*, selectedPlugs: {}*/){
        const serviceUrl = 'getFinishingJSON/';

    	return this.http.post(this.wsBaseURL + serviceUrl, {
            LocalizationID: localizationID,
            TechnologyID: technologyID/*,
            SelectedPlugs: selectedPlugs*/
        }, {headers: this.httpOptions.headers}).pipe(
    		tap(data => {
                return data;
            }),
            catchError(this.handleError)
    	);
    }

    getSwitchColor(){

    }

    getCover(serieID: number, finishingID: number, technologyID: number){
        const serviceUrl = "getCover/";

        return this.http.post(this.wsBaseURL + serviceUrl, {
            serieID : serieID,
            finishingID: finishingID,
            technologyID: technologyID
        }, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );

    }

    getCoverConfiguratorData(localizationId: number) {
        const serviceUrl = "getLocalizationCoverConfiguratorData";

        return this.http.get(this.wsBaseURL + serviceUrl + `/${localizationId}`, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );
    }

    getPossibleTechnologies(locId: number, sys: any[]){
        const serviceUrl = "getPossibleTechnologiesJSON/";

        return this.http.post(this.wsBaseURL + serviceUrl, {
            localizationID : locId,
            systems: sys}).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );
    }

    calculatePointsByParams(housing: {}, technologyID: number, locID: number, level: number, systems: any[]){
        const serviceUrl = "calculatePointsByParams/";

        return this.http.post(this.wsBaseURL + serviceUrl, {
            controlTypeID: 1,
            housingType: housing,
            technologyID: technologyID,
            level: level,
            localizationID: locID,
            systems: systems
        }, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );
    }

    getAllPackageItems(q: {}, l: {}, t:{}, a:{}){
        const serviceUrl = "getAllPackageItemsJSON/";

        return this.http.post<any[]>(this.wsBaseURL + serviceUrl, {
            quotation: q,
            localization: l,
            totalPoints: t,
            addons: a,
            isRealEstate: false
        }, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                //remove all suggested items (quantity == 0)
                let clData = data.filter(p => {return p.Quantity>0;});
                return clData;
            }),
            catchError(this.handleError)
        );
    }

    getCoverPackageItems(quotation: {}, localization: {}, totalPts: {}, coverSystem: {}){
        const serviceUrl = "getCoverPackageItemsJSON/";

        return this.http.post(this.wsBaseURL + serviceUrl, {
            quotation	: quotation,
            localization: localization,
            totalPoints	: totalPts,
            system		: coverSystem,
            isRealEstate: false
        }, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );

    }

    saveMember(user: {}, locID: number){
        const serviceUrl = "saveMemberJSON/";

        return this.http.post(this.wsBaseURL + serviceUrl, {
            User: user,
            LocalizationID: locID
        }, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );
    }

    saveQuotation(uID: number, qData:{}, pTotal:{}, a:{}){
        const serviceUrl = "saveQuotationJSON/";
        return this.http.post(this.wsBaseURL + serviceUrl, {
            UserID: uID,
            QuotationData: qData,
            PointsTotal: pTotal,
            addons: a,
        }, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );
    }
    
    updateQuotation(uID: string,locID: string, c: string, p: string, a: string, pc: string,m: string,pn: string, im: string, idsf: string, ina: string, h: string){
        const serviceUrl = "updateQuotationJSON/";
        return this.http.post(this.wsBaseURL + serviceUrl, {
            UUID: uID,
            LocalizationID: locID,
            city: c,
            province: p,
            address: a,
            postalcode: pc,
            phonenumber: pn,
            message: m,
            installeremail: im,
            idsalesforce: idsf,
            installername: ina,
            LocalizationHost: h
        }, {headers: this.httpOptions.headers}).pipe(
            tap(data => {
                return data;
            }),
            catchError(error => {
                console.log('Si è verificato un errore:', error);
                this.handleError = error;
                return error;// throwError('Qualcosa è andato storto. Riprova più tardi.');
              })
        );
    }

    getQuotationByUUID(UUID: string, localizationID: number){
        const serviceUrl = "getQuotationByUUID/";

    	return this.http.post(this.wsBaseURL + serviceUrl, {
            LocalizationID: localizationID,
            UUID: UUID,
            SecureAccessToken: ''
        }, {headers: this.httpOptions.headers}).pipe(
    		tap(data => {
                return data;
            }),
            catchError(this.handleError)
    	);
    }

    sendEmail(){
        const serviceUrl = "sendEmail/";
    }
/*
    getPrecalculatedConfigurations() {
        const serviceUrl = "getPrecalculatedConfigurations/" + this.ds.getLocalizationID();

        return this.http.get<PrecalculatedConfiguration[]>(this.wsBaseURL + serviceUrl,
            {headers: this.httpOptions.headers}
        ).pipe(
            tap(data => {
                return data;
            }),
            catchError(this.handleError)
        );
    }
*/
    private handleError(errorRes: HttpErrorResponse) {
        let errorMessage = "An unknown error occurred!";
        if (!errorRes.error || !errorRes.error.error) {
        return throwError(errorMessage);
        }
        switch (errorRes.error.error) {
        default:
            errorMessage = errorRes.error.error_description;
            break;
        }
        return throwError(errorMessage);
    }

    private addImageClassToRooms(rooms){

      rooms.forEach(room => {

        let ico = undefined;

        switch(room.RoomGroupName){
          case "roomType.IDS_ENTRANCE":
            ico = "disimpegno";
            break;
          case "roomType.IDS_KITCHEN":
            ico = "cucina";
            break;
          case "roomType.IDS_LIVINGROOMSKITCHINETTES":
            ico = "angolo-cottura";
            break;
          case "roomType.IDS_LIVINGROOM":
            ico = "soggiorno";
            break;
          case "roomType.IDS_GENERIC":
            ico = "locale-generico";
            break;
          case "roomType.IDS_BEDROOM":
            ico = "camera-letto";
            break;
          case "roomType.IDS_BATHROOM":
            ico = "bagno";
            break;
          case "roomType.IDS_LAUNDRY":
            ico = "lavanderia";
            break;
          case "roomType.IDS_CARBOX":
            ico = "garage";
            break;
          case "roomType.IDS_CEILING":
            ico = "mansarda";
            break;
          case "roomType.IDS_BASEMENT":
            ico = "taverna";
            break;  
          case "roomType.IDS_UTILITYROOM":
            ico = "ripostiglio";
            break;
          default:
            ico = undefined;
        }

        room["imageClassFromFrontEnd"] = ico;

      });

      return rooms;

    }

    private addImageClassToSystems(systems){

      systems.forEach(system => {

        let ico = undefined;

        switch(system.Code){
          case "LU1":
            ico = "luci";
            break;
          case "LOC":
            ico = "videocitofono";
            break;
          case "TAP":
            ico = "tapparelle";
            break;
          case "CAM":
            ico = "gestione-carichi";
            break;
          case "TER":
            ico = "termostato";
            break;
          case "FTT":
            ico = "prese-tradizionali";
            break;
          case "VIC":
            ico = "prese-tradizionali";
            break;            
          case "ANF":
            ico = "sicurezza";
            break;
          default:
            ico = undefined;
        }

        system["imageClassFromFrontEnd"] = ico;

      });

      return systems;

    }

    getPricelistItem(localizationID: number, itemBrand: string, itemCode: string) {
      const serviceUrl = 'getPricelistItemByCode/';

      return this.http.post<any[]>(this.wsBaseURL + serviceUrl, {
          localizationID: localizationID,
          itemBrand: itemBrand,
          itemCode: itemCode
      }, {headers: this.httpOptions.headers}).pipe(
          map(pricelistItem => {
              return pricelistItem;
          }),
          catchError(this.handleError)
      );
    }
  
  getAllInstallers(localizationID: number){
    const serviceUrl = "getInstallersList/";
    const province="";
    return this.http.post(this.wsBaseURL + serviceUrl, {
        localizationID: localizationID,
        province: province
    }, {headers: this.httpOptions.headers}).pipe(
        tap(data => {
            return data;
        }),
        catchError(error => {
            console.log('Si è verificato un errore:', error);
            this.handleError = error;
            return error;
          })
    );
    }

    rejectQuotation(uID: string,t: string,  h: string){
        const serviceUrl = "rejectQuotationJSON/";
        return this.http.post(this.wsBaseURL + serviceUrl, {
            UUID:  uID,
            SecureToken: t,
            LocalizationHost: h
        }, {headers: this.httpOptions.headers}).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                console.log('Si è verificato un errore:', error);
                this.handleError = error;
                return error;// throwError('Qualcosa è andato storto. Riprova più tardi.');
              })
        );
    }
}
